class Timeline {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.scrollerInput = self.elem.querySelector('[data-scroller-input]');
        self.scrollerContainer = self.elem.querySelector('[data-scroller-container]');
        self.scrollerCards = self.elem.querySelectorAll('[data-scroller-cards]');
    }

    init() {
        let self = this;
        self.scrollerInput.value = 0;

        self.scrollerCards.forEach(card => {
            if (card.getBoundingClientRect().left < (self.scrollerContainer.offsetWidth - 100) ) {
                card.classList.add("timeline-card__img--is-active");
            }
        });

        self.scrollerInput.oninput = function () {
            var total = self.scrollerContainer.scrollWidth - self.scrollerContainer.offsetWidth;

            self.scrollerContainer.scrollLeft = total * (this.value / 1000);
        }

        self.scrollerContainer.addEventListener("scroll", function (evt) {
            var total = self.scrollerContainer.scrollWidth - self.scrollerContainer.offsetWidth;
            self.scrollerInput.value = (self.scrollerContainer.scrollLeft / total) * 1000;

            self.scrollerCards.forEach(card => {
                if (card.getBoundingClientRect().left < (self.scrollerContainer.offsetWidth - 200) ) {
                    card.classList.add("timeline-card__img--is-active");
                } else {
                    card.classList.remove("timeline-card__img--is-active");
                }
            });
        })
    }
}

export default Timeline;
